<template>
    <el-container style="height: calc(100vh - 80px)" class="bg-white">
        <el-header style="padding: 0px; height: auto; ">
            <!-- title部 -->
            <div class="h-12 p-4 shadow-md">システム設定 > 契約会社管理</div>

            <!-- 検索部 -->
            <div class="p-5">
                <div class="border border-gray-300 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto">
                        <div class="flex flex-col md:flex-row gap-x-4">
                            <el-form-item label="契約会社名" class="md:w-80">
                                <el-input v-model="searchForm.company_name" placeholder="契約会社名(前方一致)" />
                            </el-form-item>

                            <el-button class="w-24" type="primary"
                                @click="handleSearchButton">検索</el-button>
                        </div>
                    </el-form>

                    <div class="flex justify-end">
                        <el-button class="w-24" type="primary"
                            @click="handleAddButton">新規登録</el-button>
                    </div>
                </div>
            </div>
        </el-header>

        <!-- 主显示部 -->
        <el-main style="padding-block: 0px;" v-loading="loading">
            <!-- テーブル -->
            <div class="border border-gray-300 rounded-md p-4">
                <el-table :data="mTableData" :height="'calc(100vh - 380px)'">
                    <el-table-column label="編集" width="60" align="center">
                        <template #default="scope">
                            <el-button type="primary" link @click="handleEditButton(scope.row)">
                                <el-icon>
                                    <Edit />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="company_code" label="契約会社ード" width="160"/>
                    <el-table-column prop="company_name" label="契約会社名" width="280"/>
                    <el-table-column prop="department_name" label="部署名" width="160"/>
                    <el-table-column prop="address" label="住所" min-width="360"/>
                    <el-table-column prop="license_type" label="契約ライセンス種類" width="160"/>
                    <el-table-column prop="license_expiry_date" label="契約有効期限" width="120"/>
                    <el-table-column label="削除" width="60" align="center">
                        <template #default="scope">
                            <el-button type="danger" link @click="handleDeleteButton(scope.row)">
                                <el-icon>
                                    <Delete />
                                </el-icon>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- ページネーション -->
            <div class="flex justify-end mt-2">
                <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                    :page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper" :total="mTotalRecords"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </el-main>

        <el-footer style="height: 20px;"> </el-footer>
    </el-container>

    <!-- 新規登録更新对话框 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" v-model="dialogFormVisible"
        :title="form.add_update === 'add' ? '新規登録' : '編集'" align-center>
        <el-form :model="form" :rules="rules" ref="formRef" label-width="auto">
            <el-form-item label="契約会社コード" prop="company_code">
                <el-input v-model="form.company_code" autocomplete="off" :disabled="form.add_update === 'update'"
                    placeholder="契約会社コード" />
            </el-form-item>
            <el-form-item label="契約会社名" prop="company_name">
                <el-input v-model="form.company_name" autocomplete="off" placeholder="契約会社名" />
            </el-form-item>
            <el-form-item label="部署名" prop="department_name">
                <el-input v-model="form.department_name" autocomplete="off" placeholder="部署名" />
            </el-form-item>
            <el-form-item label="住所" prop="address">
                <el-input v-model="form.address" autocomplete="off" placeholder="住所" />
            </el-form-item>
            <el-form-item label="契約ライセンス種類" prop="license_type">
                <el-input v-model="form.license_type" autocomplete="off" placeholder="契約ライセンス種類" />
            </el-form-item>
            <el-form-item label="契約有効期限" prop="license_expiry_date">
                <el-input v-model="form.license_expiry_date" autocomplete="off" placeholder="契約有効期限" />
            </el-form-item>

        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">
                    確認
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn } from 'element-plus';
import { defineComponent, onMounted, ref, nextTick } from 'vue';
import type { FormInstance, FormRules } from 'element-plus';
import { Delete, Edit } from '@element-plus/icons-vue';
import { ErrorCode, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage } from '@/components/common/errorMessage';
import { Operation, SearchRequest } from '@/components/common/request';
import { CompanyInfo } from '@/components/models/companyinfo';
import moment from 'moment';


export default defineComponent({
    name: 'MngOrgnization',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        Delete,
        // Plus,
        Edit,
        // Search,
    },
    setup() {
        const searchForm = ref<any>({
            company_name: '',
        });

        const form = ref<CompanyInfo>({
            add_update: Operation.unknow,
            company_code: '',
            company_name: '',
            department_name: '',
            license_type: '',
            license_expiry_date: '',
            address: '',
        });

        const loading = ref<boolean>(true);
        const mTableData = ref<CompanyInfo[]>([]);
        const mTotalPages = ref<number>(0);
        const mTotalRecords = ref<number>(0);
        const mCurrentPage = ref<number>(1);
        const mPageSize = ref<number>(10);

        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const dialogFormVisible = ref<boolean>(false);

        const validateDate = (_rule: any, value: any, callback: any) =>{
            const currentDate = new Date();
            const selectedDate = new Date(value);

            if(!moment(value).isValid()){
                callback(new Error('有効な時間の形式で入力してください'));
                return;
            }

            if (selectedDate <= currentDate) {
                callback(new Error('現在の日付より後の時間を指定してください'));
                return;
            } else {
                callback();
                return;
            }
        };

        const formRef = ref<FormInstance>()
        const rules = ref<FormRules>({
            company_code: [
                { required: true, message: '契約会社コードを入力してください', trigger: 'blur' },
                { min: 1, max: 10, message: '契約会社コードは1〜10文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[A-Za-z0-9]+$/, message: '契約会社コードは半角英数字で入力してください', trigger: 'blur' }
            ],
            company_name: [
                { required: true, message: '契約会社名を入力してください', trigger: 'blur' },
                { min: 2, max: 25, message: '契約会社名は2〜25文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[^<>\\/|&;$#%@"'{}()[\]]+$/, message: '契約会社名に使用できない文字が含まれています', trigger: 'blur' }
            ],
            address: [
                { required: true, message: '住所を入力してください', trigger: 'blur' },
                { min: 2, max: 25, message: '住所は2〜25文字の間で入力してください', trigger: 'blur' },
                { pattern: /^[^<>\\/|&;$#%@"'{}()[\]]+$/, message: '住所に使用できない文字が含まれています', trigger: 'blur' }
            ],
            license_type: [
                { required: true, message: '契約ライセンス種類を入力してください', trigger: 'blur' },
                { min: 2, max: 10, message: '契約ライセンス種類は2〜10文字の間で入力してください', trigger: 'blur' }
            ],
            license_expiry_date: [
                { required: true, message: '契約有効期限を入力してください', trigger: 'blur' },
                { pattern: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/, message: '契約有効期限はYYYY-MM-DDの形式で入力してください', trigger: 'blur' },
                { validator: validateDate, trigger: 'blur' },
            ]
        })

        /***** マウント **************************/
        onMounted(() => {
            getCompanyList();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            getCompanyList();
        };

        const handleAddButton = () => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.add,
                    company_code: '',
                    company_name: '',
                    department_name: '',
                    license_type: '',
                    license_expiry_date: '',
                    address: '',
                };
            });
        };

        const handleEditButton = (row: CompanyInfo) => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.update,
                    company_code: row.company_code,
                    company_name: row.company_name,
                    department_name: row.department_name,
                    license_type: row.license_type,
                    license_expiry_date: row.license_expiry_date,
                    address: row.address,
                };
            });
        };

        const handleDeleteButton = (row: CompanyInfo) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteCompany(row);
            }).catch(() => {
            });
        };


        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid) => {
                if (valid) {
                    if (form.value.add_update === Operation.add) {
                        addCompany();
                    } else if (form.value.add_update === Operation.update) {
                        updateCompany(form.value);
                    }
                    dialogFormVisible.value = false;
                }
            })
        }

        const handleSizeChange = (size: number) => {
            mPageSize.value = size;
            getCompanyList();
        };
        const handleCurrentChange = (page: number) => {
            mCurrentPage.value = page;
            getCompanyList();
        };

        /***** DB 操作 **************************/
        const apiCall = async (method: 'get' | 'post' | 'put' | 'delete', url: string, data?: any) => {
            try {
                loading.value = true;
                const res: AxiosResponse<ResponseData<any>> = await axios({
                    method,
                    url,
                    data,
                    params: method === 'get' ? data : undefined, // Use params only for GET requests
                });

                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    if (method !== 'get') {
                        ElMessage.success(res.data.message); // Show success message for non-GET requests
                    }
                    return res.data;
                } else {
                    ElMessage.error(res.data.message);
                    return null;
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(error as Error));
                return null;
            } finally {
                loading.value = false;
            }
        };

        const getCompanyList = async () => {
            const params: SearchRequest = {
                page: mCurrentPage.value,
                limit: mPageSize.value,
                company_name: searchForm.value.company_name,
            };
            const data = await apiCall('get', '/api/companies/search', params);
            if (data) {
                const { total, totalPages, currentPage, data: companyData } = data;
                mCurrentPage.value = currentPage!;
                mTotalPages.value = totalPages!;
                mTotalRecords.value = total!;
                mTableData.value = companyData!;
            }
        };

        const addCompany = async () => {
            await apiCall('post', '/api/companies', form.value);
            getCompanyList();
        };

        const updateCompany = async (row: CompanyInfo) => {
            await apiCall('put', `/api/companies/${row.company_code}`, row);
            getCompanyList();
        };

        const deleteCompany = async (row: CompanyInfo) => {
            await apiCall('delete', `/api/companies/${row.company_code}`);
            getCompanyList();
        };

        return {
            searchForm,
            form,
            dialogFormVisible,
            loading,
            mTableData,
            mCurrentPage,
            mPageSize,
            mTotalPages,
            mTotalRecords,
            size,
            disabled,
            background,
            handleSearchButton,
            handleAddButton,
            handleEditButton,
            handleDeleteButton,
            handleSizeChange,
            handleCurrentChange,
            handleAddUpdateSubmit,
            formRef,
            rules,
        }
    }
});
</script>